import {
  Badge,
  BadgeOverlay,
  COUNT_CUTOFF,
  Props,
  Wrapper,
  text,
} from "./CountBadge.Parts";

export const CountBadge = ({
  count,
  children,
  variant = "primary",
  size = "normal",
}: Props) => {
  if (count < 1) return children ? children : null;

  if (!children)
    return (
      <Badge variant={variant} $size={size} $cutoff={count > COUNT_CUTOFF}>
        {count > COUNT_CUTOFF ? text.cutoffText : count}
      </Badge>
    );

  return (
    <Wrapper>
      {children}
      <BadgeOverlay
        variant={variant}
        $size={size}
        $cutoff={count > COUNT_CUTOFF}
      >
        {count > COUNT_CUTOFF ? text.cutoffText : count}
      </BadgeOverlay>
    </Wrapper>
  );
};
